import React from "react";
import "../../../../styles/managementTheme.css";
import "../styles/pagos.css";

const currency = new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD" });

const getValueClass = (value) => {
  const length = String(value ?? "").length;
  if (length >= 14) return "value-xs";
  if (length >= 12) return "value-sm";
  if (length >= 10) return "value-md";
  return "";
};

const SummaryCard = ({ label, value, icon, accent = "secondary", active, onClick }) => (
  <div className="w-100">
    <div
      className={`management-stat-card pagos-summary-card h-100 ${accent ? `accent-${accent}` : ""} ${active ? "active" : ""}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className="management-stat-icon">
        <i className={`bi ${icon}`} />
      </div>
      <div>
        <p className="management-stat-label mb-1">{label}</p>
        <div className={`management-stat-value ${getValueClass(value)}`}>{value}</div>
      </div>
    </div>
  </div>
);

export default function PagosSummary({ resumen, onQuickFilter, activeKey }) {
  return (
    <div className="management-card mb-4">
      <div className="pagos-summary-grid">
        <SummaryCard
          label="Cobros pendientes"
          value={resumen.pendientes || 0}
          icon="bi-hourglass-split"
          accent="warning"
          active={activeKey === "pendientes"}
          onClick={() => onQuickFilter?.("pendientes")}
        />
        <SummaryCard
          label="Pagos registrados"
          value={resumen.total || 0}
          icon="bi-cash-stack"
          accent="primary"
          active={activeKey === "total"}
          onClick={() => onQuickFilter?.("total")}
        />
        <SummaryCard
          label="Pago parcial"
          value={resumen.parciales || 0}
          icon="bi-wallet2"
          accent="info"
          active={activeKey === "parcial"}
          onClick={() => onQuickFilter?.("parcial")}
        />
        <SummaryCard
          label="Pagadas"
          value={resumen.pagados || 0}
          icon="bi-check-circle"
          accent="success"
          active={activeKey === "pagado"}
          onClick={() => onQuickFilter?.("pagado")}
        />
        <SummaryCard
          label="Cobrado este mes"
          value={currency.format(resumen.montoMes || 0)}
          icon="bi-calendar-event"
          accent="secondary"
          active={activeKey === "mes"}
          onClick={() => onQuickFilter?.("mes")}
        />
        <SummaryCard
          label="Cobrado hoy"
          value={currency.format(resumen.montoHoy || 0)}
          icon="bi-clock-history"
          accent="secondary"
          active={activeKey === "hoy"}
          onClick={() => onQuickFilter?.("hoy")}
        />
      </div>
    </div>
  );
}
